import { localStorageUtils } from '@/utils/localStorage';

const LAST_USED_EMAIL_KEY = 'lastUsedEmail';
const EMAIL_EXPIRATION_KEY = 'lastUsedEmailExpiry';
const EXPIRY_DAYS = 30;
const EXPIRY_MS = EXPIRY_DAYS * 24 * 60 * 60 * 1000; // days in milliseconds

/** Remembers the email for the next visit, with a new expiry. */
export function rememberEmail(email: string): void {
    const expirationTime = Date.now() + EXPIRY_MS;
    localStorageUtils.set(LAST_USED_EMAIL_KEY, email);
    localStorageUtils.set(EMAIL_EXPIRATION_KEY, expirationTime);
}

/** Clears both keys, so a stale email is never offered again. */
export function forgetEmail(): void {
    localStorageUtils.remove(LAST_USED_EMAIL_KEY);
    localStorageUtils.remove(EMAIL_EXPIRATION_KEY);
}

export type CachedEmail =
    | { status: 'none' }
    | { status: 'valid'; email: string }
    | { status: 'expired' };

/** The remembered email, if one was stored with an expiry. */
export function readCachedEmail(): CachedEmail {
    const cachedEmail = localStorageUtils.get<string | null>(LAST_USED_EMAIL_KEY, null);
    const expiryTime = localStorageUtils.get<number | null>(EMAIL_EXPIRATION_KEY, null);

    if (cachedEmail && typeof expiryTime === 'number' && expiryTime > 0) {
        return Date.now() < expiryTime
            ? { status: 'valid', email: cachedEmail }
            : { status: 'expired' };
    }
    return { status: 'none' };
}
